import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-privacy-scrore',
  templateUrl: './privacy-scrore.component.html'
})
export class PrivacyScroreComponent implements OnInit {

  @Input() deviceId = ''
  constructor(private _Service: ApiService, private router: Router, private commonService: CommonService) { }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.getDashboardDataById()
  }
  showUrl: boolean = false;
  ngOnInit(): void {
    if (this.router.url == '/home/main-content') {
      this.showUrl = true;
    }
  }
  securityScoreStatus: any;
  color: any;
  securityColor: any;
  securityRangeLeve1: any;
  securityRangeLeve2: any;
  getDeviceId: string = ''
  delimitervalue: number = 1;
  public canvasWidth = 300
  public needleValue = 1;
  public centralLabel = ''
  privacyScore: number = 0;
  privacyTotalScore: number = 0;
  privacyRecommendations: any;
  privacyScoreStatus: any
  statusBg: string = '';
  statusClr: string = '';
  options = {};
  options1 = {};
  isLoading: boolean = false;
  getDashboardDataById() {
    try {
      this.isLoading = true;
      this._Service.getService(this._Service.API_URL.getDashboardDataById + this.deviceId).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.privacyScore = response.data.privacyScore;
          this.commonService.privacyscore.next(JSON.stringify(this.privacyScore));
          this.privacyTotalScore = response.data.privacyTotalScore;
          this.privacyRecommendations = response.data.privacyRecommendations;
          this.delimitervalue = (response.data.privacyScore / 10);
          this.privacyScoreStatus = response.data.privacyScoreStatus;
          if (this.delimitervalue >= 100) {
            this.delimitervalue = 99.9;
          }
          if (this.privacyScore <= 250) {
            this.color = '#FF4B2B'
          } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
            this.color = '#FB6C6C'
          } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
            this.color = '#F59E0B'
          } else {
            this.color = '#1ECB1A'
          }
          if (this.privacyScore >= 50) {
            this.securityColor = 'rgb(58, 215, 55, 1)'
          } else {
            this.securityColor = 'rgb(255, 65, 65, 1)'
          }

          this.options = {
            hasNeedle: true,
            needleColor: '#023047',
            needleUpdateSpeed: 1000,
            arcColors: [this.color, 'lightgray'],
            arcDelimiters: [this.delimitervalue ? this.delimitervalue : 1],
            needleStartValue: 0.1,
          }
          if (this.privacyScore <= 250) {
            this.statusBg = "#FDDDDD";
            this.statusClr = "#FF4B2B";
          } else if (this.privacyScore >= 251 && this.privacyScore <= 500) {
            this.statusBg = "#FFF0F0";
            this.statusClr = "#FB6C6C";
          } else if (this.privacyScore >= 501 && this.privacyScore <= 800) {
            this.statusBg = "#FDECCE";
            this.statusClr = "#F59E0B";
          } else {
            this.statusBg = "#D5FED6";
            this.statusClr = "#1ECB1A";
          }
        }


      })
    } catch (error) {
      console.log(error);

    }

  }
}
